module.exports = __webpack_public_path__ + "img/SharingDocuments03.886846e4.svg";